import { Button } from "./ui/button";
import { Card } from "./ui/card";
import { Users, MapPin, Calendar, Wifi } from "lucide-react";
import { ImageWithFallback } from "./figma/ImageWithFallback";

export function HeroSection() {
  return (
    <section id="home" className="relative bg-gradient-to-br from-fun-blue/10 via-white to-fun-yellow/20 py-20">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-fun-teal/10 border border-fun-teal/20 px-4 py-2 rounded-full mb-6">
              <Users className="h-4 w-4 text-fun-teal" />
              <span className="text-fun-teal font-medium">55+ Community</span>
            </div>
            
            <h1 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight">
              Welcome to Your Perfect 
              <span className="text-primary block">Desert Oasis</span>
            </h1>
            
            <p className="text-lg mb-8 text-fun-navy/80 leading-relaxed">
              Nestled in the lower Moapa Valley between pink flat-top mesas with majestic purple mountains as a backdrop, 
              you are only minutes away from the breathtaking views of Lake Mead and the Valley of Fire State Park.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <Button size="lg" className="bg-primary hover:bg-primary/90">
                Make Reservation
              </Button>
              <Button size="lg" variant="outline" className="border-fun-teal text-fun-teal hover:bg-fun-teal hover:text-white">
                View Rates
              </Button>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="flex items-center gap-2">
                <MapPin className="h-5 w-5 text-fun-teal" />
                <span className="text-sm text-fun-navy">Overton, Nevada</span>
              </div>
              <div className="flex items-center gap-2">
                <Calendar className="h-5 w-5 text-fun-teal" />
                <span className="text-sm text-fun-navy">Oct-May Season</span>
              </div>
            </div>
          </div>

          <div className="relative">
            <ImageWithFallback
              src="https://images.unsplash.com/photo-1544373865-3c2ac2d4d9e8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
              alt="RV Park with mountain backdrop"
              className="rounded-lg shadow-xl w-full h-[400px] object-cover"
            />
            
            {/* Floating info cards */}
            <Card className="absolute -bottom-6 -left-6 p-4 bg-white/95 backdrop-blur shadow-lg border-fun-blue/20">
              <div className="flex items-center gap-3">
                <div className="bg-fun-blue/10 p-2 rounded-lg">
                  <Wifi className="h-6 w-6 text-fun-blue" />
                </div>
                <div>
                  <p className="font-medium text-fun-navy">Free WiFi</p>
                  <p className="text-sm text-muted-foreground">Available throughout park</p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
}